import { PageShell } from "@/components/PageShell";
import { Journal } from "@/components/Journal";

export default function JournalPage() {
  return (
    <PageShell>
      <Journal />
    </PageShell>
  );
}
